import { useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/85 backdrop-blur-md border-b border-background-200/80">
      <nav className="mx-auto max-w-7xl px-4 md:px-6 flex items-center justify-between h-16">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
            <i className="ri-eye-line" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-semibold tracking-tight text-foreground-950">
            吃瓜捷克
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#faq"
            className="inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-foreground-950 px-3 py-2 rounded-md whitespace-nowrap"
          >
            <i className="ri-error-warning-line" aria-hidden="true"></i>
            资料纠错
          </a>
          <a
            href="#accounts"
            className="inline-flex items-center gap-1.5 text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 px-4 py-2 rounded-md whitespace-nowrap"
          >
            直达账号
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-800 rounded-md border border-background-200"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/95 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-2 px-2 rounded-md text-sm text-foreground-800 hover:bg-background-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#accounts"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex items-center justify-center gap-1.5 text-sm font-medium bg-primary-500 text-background-50 px-4 py-2.5 rounded-md whitespace-nowrap"
          >
            直达账号
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      )}
    </header>
  );
}